import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";
export const resetFrequency = v.union(
  v.literal("never"),
  v.literal("yearly"),
  v.literal("monthly"),
);
export const tableTypes = v.union(
  v.literal("quotations"),
  v.literal("invoices"),
  v.literal("credit_notes"),
  v.literal("debit_notes"),
  v.literal("correlatives"),
  v.literal("clients"),
  v.literal("products"),
  v.literal("services"),
  v.literal("suppliers"),
  v.literal("sales"),
  v.literal("branches"),
  v.literal("document_records"),
  v.literal("document_templates"),
  v.literal("work_orders"),
  v.literal("reports"),
  v.literal("purchase_orders"),
);

export const validatorNomenclatureConfig = v.object({
  name: v.optional(v.string()),
  branchId: v.optional(v.id("branches")), // Sucursal específica (opcional)
  prefix: v.optional(v.string()), // Default: 'COT'
  separator: v.optional(v.string()), // Default: '-'
  dateFormat: v.optional(v.string()), // Default: 'YYYY'
  counterDigits: v.optional(v.number()), // Default: 4
  counterStart: v.optional(v.number()), // Default: 1
  currentCounter: v.optional(v.number()), // Default: 1
  resetFrequency: v.optional(resetFrequency), // never/yearly/monthly
  lastResetDate: v.optional(v.number()), // Date as timestamp
  table: v.optional(tableTypes), // Table this config applies to

  internalControl,
});

export const nomenclature = defineTable(validatorNomenclatureConfig)
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_table", ["table"])
  .index("by_company_and_table", ["internalControl.companyId", "table"])
  .index("by_branch_and_table", ["internalControl.branchId", "table"])
  .index("by_reset_frequency", ["resetFrequency"])

  .index("by_company_id", ["internalControl.companyId"]) // Relación con empresas
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
